module.exports = __webpack_public_path__ + "img/960.823b28ab.gif";